export default __webpack_public_path__ + "static/media/founded-on.fd25f143.png";